<div class="selection-status-badge" matTooltip="{{ state.labelAndIcon.label }}">
  <img src="{{ state.labelAndIcon.icon }}" alt="{{ state.labelAndIcon.label }}" />
</div>
